/* Fernwood House v5 motion. Replaces fh-v4-motion.js.
   1) Deferred card images load after window load (keeps LCP on the hero). Runs for everyone.
   2) GSAP + ScrollTrigger load from jsDelivr only when motion is allowed, after the page is idle.
      Only elements below the fold are animated, from an already-laid-out state. No scroll-jacking, no pinning.
      Any failure leaves the page fully visible. */
(() => {
  'use strict';
  const loadDeferredImages = () => {
    document.querySelectorAll('img[data-fh-src]').forEach((img) => {
      if (img.dataset.fhSrcset) img.srcset = img.dataset.fhSrcset;
      img.src = img.dataset.fhSrc;
      img.style.visibility = '';
      img.removeAttribute('data-fh-src');
    });
  };
  const onLoad = (fn) => (document.readyState === 'complete' ? fn() : window.addEventListener('load', fn, { once: true }));
  onLoad(loadDeferredImages);

  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const CDN = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';
  const load = (src) => new Promise((ok, fail) => {
    const s = document.createElement('script');
    s.src = src; s.async = true; s.onload = ok; s.onerror = fail;
    document.head.appendChild(s);
  });

  const run = () => {
    const { gsap, ScrollTrigger } = window;
    if (!gsap || !ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    const fold = window.innerHeight;
    const below = (el) => el.getBoundingClientRect().top > fold * 0.9;
    const ease = 'expo.out';

    // Product cards: gentle rise, staggered per grid.
    document.querySelectorAll('.fh-duo__grid, .fh-guide__grid').forEach((grid) => {
      const items = Array.from(grid.children).filter(below);
      if (!items.length) return;
      gsap.from(items, { y: 18, autoAlpha: 0, duration: 0.9, ease, stagger: 0.07, clearProps: 'all',
        scrollTrigger: { trigger: grid, start: 'top 85%', once: true } });
    });

    // Signature moment: care-label rows and stitch dividers draw in.
    document.querySelectorAll('.fh-labelcard__rows, .fh-trust__list').forEach((group) => {
      if (!below(group)) return;
      gsap.from(group.children, { autoAlpha: 0, x: -10, duration: 0.7, ease, stagger: 0.08, clearProps: 'all',
        scrollTrigger: { trigger: group, start: 'top 85%', once: true } });
    });

    // Threshold bar fills from zero when it enters.
    document.querySelectorAll('.fh-ship__fill').forEach((fill) => {
      if (!below(fill)) return;
      gsap.from(fill, { scaleX: 0, duration: 1.2, ease, scrollTrigger: { trigger: fill, start: 'top 90%', once: true } });
    });

    // Section headings: clip reveal (text stays in the DOM and readable).
    document.querySelectorAll('.fh-h2').forEach((h) => {
      if (!below(h)) return;
      gsap.from(h, { clipPath: 'inset(0 0 100% 0)', y: 12, duration: 0.9, ease, clearProps: 'clipPath,transform',
        scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    });
  };

  const start = () => load(CDN + 'gsap.min.js').then(() => load(CDN + 'ScrollTrigger.min.js')).then(run)
    .catch((e) => console.warn('[fh-motion] GSAP not loaded; page stays static.', e));
  onLoad(() => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 600)));
})();
